import _classCallCheck from "C:\\Users\\dell\\Downloads\\Projects\\fezile-fashion-skills-academy\\site\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\dell\\Downloads\\Projects\\fezile-fashion-skills-academy\\site\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "C:\\Users\\dell\\Downloads\\Projects\\fezile-fashion-skills-academy\\site\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "C:\\Users\\dell\\Downloads\\Projects\\fezile-fashion-skills-academy\\site\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
import { __rest } from "tslib";
import * as React from 'react';
import { createFocusTrap } from 'focus-trap';
var FocusTrapBase = /*#__PURE__*/function (_React$Component) {
  _inherits(FocusTrapBase, _React$Component);
  var _super = _createSuper(FocusTrapBase);
  function FocusTrapBase(props) {
    var _this;
    _classCallCheck(this, FocusTrapBase);
    _this = _super.call(this, props);
    _this.divRef = _this.props.innerRef || React.createRef();
    if (typeof document !== 'undefined') {
      _this.previouslyFocusedElement = document.activeElement;
    }
    return _this;
  }
  _createClass(FocusTrapBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // We need to hijack the returnFocusOnDeactivate option,
      // because React can move focus into the element before we arrived at
      // this lifecycle hook (e.g. with autoFocus inputs). So the component
      // captures the previouslyFocusedElement in componentWillMount,
      // then (optionally) returns focus to it in componentWillUnmount.
      this.focusTrap = createFocusTrap(this.divRef.current, Object.assign(Object.assign({}, this.props.focusTrapOptions), {
        returnFocusOnDeactivate: false
      }));
      if (this.props.active) {
        this.focusTrap.activate();
      }
      if (this.props.paused) {
        this.focusTrap.pause();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.active && !this.props.active) {
        this.focusTrap.deactivate();
      } else if (!prevProps.active && this.props.active) {
        this.focusTrap.activate();
      }
      if (prevProps.paused && !this.props.paused) {
        this.focusTrap.unpause();
      } else if (!prevProps.paused && this.props.paused) {
        this.focusTrap.pause();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.focusTrap.deactivate();
      if (this.props.focusTrapOptions.returnFocusOnDeactivate !== false && this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
        this.previouslyFocusedElement.focus({
          preventScroll: this.props.preventScrollOnDeactivate
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
        children = _a.children,
        className = _a.className,
        focusTrapOptions = _a.focusTrapOptions,
        active = _a.active,
        paused = _a.paused,
        preventScrollOnDeactivate = _a.preventScrollOnDeactivate,
        innerRef = _a.innerRef,
        rest = __rest(_a, ["children", "className", "focusTrapOptions", "active", "paused", "preventScrollOnDeactivate", "innerRef"]);
      return React.createElement("div", Object.assign({
        ref: this.divRef,
        className: className
      }, rest), children);
    }
  }]);
  return FocusTrapBase;
}(React.Component);
FocusTrapBase.displayName = 'FocusTrap';
FocusTrapBase.defaultProps = {
  active: true,
  paused: false,
  focusTrapOptions: {},
  preventScrollOnDeactivate: false
};
export var FocusTrap = React.forwardRef(function (props, ref) {
  return React.createElement(FocusTrapBase, Object.assign({
    innerRef: ref
  }, props));
});